<template>
		<div class="content-fr">
      <div class="" @click="back()" style="position: absolute;left: 30px;top: 30px;z-index: 100">
        <img style="width: 70px;" src="static/images/retrun.png">
      </div>

      <iframe
        v-if="user_id"
        class="iframe"
        :src="'https://game.gbgts.com/pages/game/redBoxRain/index?user_id=' + user_id + '&lang=' + isEN + '&t=' + Date.now()"
        @load="onIframeLoad"
      ></iframe>

<!--      <iframe-->
<!--        v-if="user_id"-->
<!--        class="iframe"-->
<!--        :src="'http://localhost:8081/pages/game/redBoxRain/index?user_id=' + user_id + '&lang=' + isEN + '&t=' + Date.now()"-->
<!--        @load="onIframeLoad"-->
<!--      ></iframe>-->
		</div>
</template>
<script>

export default {
    components:{

    },
    data() {

    return {
			info:{},
      user_id:'',
      invited_code:'',
      invitedAlert:'',
      answerReson:{},
      isEN:'bur'
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {

    },
    created(){
      this.$parent.loadModal(true);
      this.isEN = localStorage.getItem('lang')?localStorage.getItem('lang'):"bur"
      this.user_id = this.$route.query.user_id
      // this.getHome();
    },
  methods: {
      onIframeLoad(){
        this.$parent.loadModal(false);
      },
		  back(){
        this.$router.go(-1);
		  },
      getHome(){
        let that =this;
        that.$api.get('/api/user/info',null,r =>{
          that.$parent.returnCode(r,function(){
          that.info = r.data
          that.user_id = r.data.id
        });
        })
      }
	}
}
</script>
<style>
  .iframe{width: 100%;height: 100vh;border: none;}
</style>



// WEBPACK FOOTER //
// src/page/gameBoxRain.vue